import {
  BadgeCheck,
  Crown,
  Gem,
  Lock,
  LockKeyhole,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldHalf,
  Sparkles,
  Umbrella,
} from 'lucide-react';

/**
 * Shared icon set for stop-loss cards (admin editor + user-facing grid).
 * Keys are stored on `investment.stopLossPackages[].iconKey` in SiteSettings.
 */
export const STOP_LOSS_ICONS = {
  shield: Shield,
  shieldCheck: ShieldCheck,
  shieldAlert: ShieldAlert,
  shieldHalf: ShieldHalf,
  lock: Lock,
  lockKeyhole: LockKeyhole,
  umbrella: Umbrella,
  crown: Crown,
  gem: Gem,
  sparkles: Sparkles,
  badgeCheck: BadgeCheck,
};

export const STOP_LOSS_ICON_OPTIONS = [
  { key: 'shield', label: 'Shield' },
  { key: 'shieldCheck', label: 'Shield with check' },
  { key: 'shieldAlert', label: 'Shield with alert' },
  { key: 'shieldHalf', label: 'Shield (half)' },
  { key: 'lock', label: 'Lock' },
  { key: 'lockKeyhole', label: 'Lock (keyhole)' },
  { key: 'umbrella', label: 'Umbrella' },
  { key: 'crown', label: 'Crown' },
  { key: 'gem', label: 'Gem' },
  { key: 'sparkles', label: 'Sparkles' },
  { key: 'badgeCheck', label: 'Badge with check' },
];

export const STOP_LOSS_ICON_KEYS = STOP_LOSS_ICON_OPTIONS.map((o) => o.key);

export const STOP_LOSS_ACCENTS = [
  { key: 'amber', label: 'Amber' },
  { key: 'blue', label: 'Blue' },
  { key: 'green', label: 'Green' },
];

export const STOP_LOSS_ACCENT_KEYS = STOP_LOSS_ACCENTS.map((a) => a.key);

export function resolveStopLossIcon(iconKey) {
  return STOP_LOSS_ICONS[iconKey] || Shield;
}
